module.exports = __webpack_public_path__ + "static/media/phone.a00d9f98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/phone.png
// module id = 617
// module chunks = 0